import React from 'react';
import cn from 'classnames';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import styles from './ProjectorNameEdit.module.css';

// Controlled "Now showing on <Name>'s Projector" with inline edit. State (fetch
// + save) lives in the page so it can render in two positions (block vs inline)
// without refetching. `variant`: 'block' (default header) | 'inline' (condensed).
const ProjectorNameEdit = ({
  variant = 'block', label, editing, draft, saving, dark = false,
  onStartEdit, onDraftChange, onSave, onCancel,
}) => (
  <div className={cn(styles.wrap, { [styles.inline]: variant === 'inline', [styles.dark]: dark })}>
    {variant === 'block' && !editing && <span className={styles.label}>Now showing on</span>}
    {editing ? (
      <span className={styles.editRow}>
        <input
          className={styles.input}
          value={draft}
          autoFocus
          disabled={saving}
          onChange={(e) => onDraftChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') onSave(); if (e.key === 'Escape') onCancel(); }}
          onBlur={onSave}
          placeholder="Projector name"
        />
        <span className={styles.suffix}>&apos;s Projector</span>
        <button type="button" className={styles.save} onMouseDown={(e) => e.preventDefault()} onClick={onSave} disabled={saving}>Save</button>
        <button type="button" className={styles.cancel} onMouseDown={(e) => e.preventDefault()} onClick={onCancel} disabled={saving}>Cancel</button>
      </span>
    ) : (
      <button type="button" className={styles.valueBtn} onClick={onStartEdit} title="Edit display name">
        <span className={styles.value}>{label}</span>
        <EditRoundedIcon className={styles.editIcon} fontSize="inherit" />
      </button>
    )}
  </div>
);

export default ProjectorNameEdit;
